export const API_URL = {
  /* START: auth service */
  // auth
  signin: "/authentication-service/v1/login",
  signup: "/authentication-service/v1/registration",
  forgotPassword: "/authentication-service/v1/forget-passwrod",
  changePassword: "/authentication-service/v1/change-password",
  resetPassword: "/authentication-service/v1/reset-password",
  getLocation: "/authentication-service/v1/location", //   geo vul ase
  updateCompleteProfile: "/authentication-service/v1/employee-profile-complete",
  profileUpdate: "/authentication-service/v1/profile-update",
  companyProfileUpdate: "/authentication-service/v1/company-profile-update",
  sendVerificationEmail: "/authentication-service/v1/send-verification-email",
  verifyEmail: "/authentication-service/v1/verify-email",

  /* START: employee service */
  // department
  getDepartments: "/departments/v1/data",
  getDepartmentDetails: "/departments/v1/details",
  addDepartment: "/departments/v1/create",
  updateDepartment: "/departments/v1/update",
  updateDepartmentStatus: "/departments/v1/department-status-update",

  // designation
  getDesignations: "/business-role/v1/data", // search kaj korena
  getDesignationDetails: "/business-role/v1/details",
  addDesignation: "/business-role/v1/create",
  updateDesignation: "/business-role/v1/update",
  updateDesignationStatus: "/business-role/v1/business-role-status-update",

  // employee
  getEmployees: "/employee-management/v1/data", // search, department filter kaj korena
  getEmployeeDetails: "/employee-management/v1/details",
  getMe: "/employee-management/v1/details-me",
  addEmployee: "/employee-management/v1/create",
  updateProfilePicture: "/employee-management/v1/update-profile-picture",
  updateEmployeeOfficialData: "/employee-management/v1/update-official-data",
  updateEmployeePersonalData: "/employee-management/v1/update-personal-data",
  updateEmployeeFinancialData: "/employee-management/v1/update-financial-data",
  updateEmployeeSalaryData: "/employee-management/v1/update-salary-data",
  updateEmployeeEmergencyContact:
    "/employee-management/v1/update-emergency-contact",
  updateEmployeeAdditionalData:
    "/employee-management/v1/update-additional-data",
  updateEmployeeStatus: "/employee-management/v1/employee-status-update",
  updateEmployeeBulkStatus:
    "/employee-management/v1/employee-status-bulk-update",
  sendInvite: "/employee-management/v1/invite-with-email",
  uploadEmployeeBkashData:
    "/employee-management/v1/create-or-update-bkash-data-of-employee-queue",
  uploadPhotoInEmployee: "/employee-management/v1/update-photo",
  reInvited: "/employee-management/v1/re-invite-with-email",
  activeInvited: "/employee-management/v1/activate-invite-employee",
  deleteInvited: "/employee-management/v1/invitation-delete",
  downloadEmployeeDetails: "/employee-management/v1/download/details",
  removeAdditionalData: "/employee-additional-field/remove-additional-data",
  getEmployeesListExport: "/employee-management/v1/employees-list-download",
  getEmployeeManagementData: "/employee-management/v1/data",
  uploadEmployeeInfo: "/employee-management/v1/bulk-employee-data-upload-queue",

  // employee additional field
  getEmployeeAdditionalFields: "/employee-additional-field/v1/data",
  getEmployeeAdditionalFieldDetails: "/employee-additional-field/v1/details", // *-
  addEmployeeAdditionalField: "/employee-additional-field/v1/create", // only admin er create hoy
  updateEmployeeAdditionalField: "/employee-additional-field/v1/update",
  getAdditionalData: "/employee-additional-field/v1/additional-section",
  getBusinessData: "/employee-management/v1/business",
  syncCheckIn: "/attendance-device/sync-checkin-without-queue",
  syncCheckOut: "/attendance-device/sync-checkout-without-queue",
  // Workstation
  getWorkStations: "/work-stations/v1/data",
  getWorkStationDetails: "/work-stations/v1/details",
  addWorkStation: "/work-stations/v1/create",
  updateWorkStation: "/work-stations/v1/update",
  updateWorkStationStatus: "/work-stations/v1/work-station-status-update",

  // Workstation
  getExpenseUnits: "/expense-unit/v1/data",
  getExpenseUnitDetails: "/expense-unit/v1/details",
  addExpenseUnit: "/expense-unit/v1/create",
  updateExpenseUnit: "/expense-unit/v1/update",
  updateExpenseUnitStatus: "/expense-unit/v1/expense-unit-status-update",

  /* START: Holiday service */
  getHolidays: "/business-holiday/v1/data",
  getHolidaysByDate: "/business-holiday/v1/get-holiday-by-date-to-date",
  getHolidayDetails: "/business-holiday/v1/details",
  addHoliday: "/business-holiday/v1/create-queue",
  updateHoliday: "/business-holiday/v1/update-queue",
  deleteHoliday: "/business-holiday/v1/delete",

  /* START: Business Shift service */
  getBusinessShifts: "/business-shift/v1/data",
  getBusinessShiftDetails: "/business-shift/v1/details",
  addBusinessShift: "/business-shift/v1/create", // create hoyna
  updateBusinessShift: "/business-shift/v1/update", // update hoyna
  updateBusinessShiftStatus: "/business-shift/v1/shift-status-update",

  /* START: Shift Assign To Employee */
  getShiftCalender: "/shift-assign/v1/shift-calender",
  assignToShift: "/shift-assign/v1/assign-shift",
  assignGeneralAttendance: "/shift-assign/v1/assign-general-attendance",
  unAssigned: "/shift-assign/v1/unassign-shifts",
  getShiftCartData: "/shift-assign/v1/dashboard-cart",
  updatePreviousWeekendStatus:
    "/shift-assign/v1/update-previous-weekend-status-queue",
  updatePreviousAllGeneral: "/shift-assign/v1/make-previous-all-general-queue",
  shiftCalenderEmployee: "/shift-assign/v1/shift-calender-by-employee",
  getAttendanceLog: "/attendance/v1/get-wifi-auto-all-log-by-id",

  /* START: Expense Service */
  expenseEmployee: "/expense/v1/expense-list-monthly-by-admin",
  expenseMonthlyDetails: "/expense/v1/expense-list-by-employee",
  createExpense: "/expense/v1/create",
  expenseUpdate: "/expense/v1/update-by-admin",
  expenseAccept: "/expense/v1/accept-expense",
  expenseReject: "/expense/v1/reject-expense",
  getExpenseReportExcel: "/expense/v1/expense-report-excel",
  getExpenseReportDetailsExcel: "/expense/v1/expense-details-report-excel",
  downloadEmployeeExpense: "/expense/v1/download/expense-list-by-employee",
  getDashboardExpense: "/expense/v1/expense-list-dashboard-stats",

  /* START: Announcement Service */
  createAnnouncement: "/announcement/v1/create",
  getAnnouncementList: "/announcement/v1/data",
  getAnnouncementDetails: "/announcement/v1/details",
  updateAnnouncement: "/announcement/v1/update",

  getSupportList: "/support/v1/support-list",
  getSupportDetails: "/support/v1/support-details",
  supportClose: "/support/v1/support-close",
  getComment: "/support/v1/comments",
  addComment: "/support/v1/comment",

  /* START: Attendance Setting */
  getAttendanceSettingData: "/attendance-setting/v1/data",
  addAttendanceSetting: "/attendance-setting/v1/create-queue",
  createUnpaidPolicy: "/attendance-setting/v1/create-unpaid-leave-policy",
  getUnpaidLeavePolicy: "/attendance-setting/v1/get-unpaid-leave-policy",
  getOfficeSettingLog:
    "/operational-setting/v1/get-office-setting-changes-logs",
  getSelectedEmployees: "/operational-setting/v1/get-attendance-type-user-list",

  /* START: Operational Setting */
  getOfficeSettingData: "/operational-setting/v1/data",
  addOfficeSetting: "/operational-setting/v1/create-queue",

  /* START: Attendance Report */
  getDailyAttendanceReport: "/attendance/v1/daily-attendace-report",
  getCustomAttendanceReport: "/attendance/v1/custom-attendace-report",
  getCustomAttendanceByEmployee:
    "/attendance/v1/custom-attendace-report-by-employee",
  attendanceReconciliation: "/attendance/v1/attendance-reconciliation",
  getDashboardAttendanceAnalyticsData:
    "/attendance/v1/dashboard-attendance-analytics-data-alternative",
  getAttendanceExport: "/attendance/v1/custom-attendance-export",

  /* START: Leave Type */
  getLeaveTypeList: "/leave-type/v1/data",
  updateLeaveType: "/leave-type/v1/update",
  addLeaveType: "/leave-type/v1/create",
  getLeaveTypeDetails: "/leave-type/v1/leave-type-details",

  getLeaveAdjustmentList: "/leave-adjustment-policies/v1/data",
  getLeaveAdjustmentDetails: "/leave-adjustment-policies/v1/details",
  addAdjustment: "/leave-adjustment-policies/v1/create",
  updateAdjustment: "/leave-adjustment-policies/v1/update",
  updateAdjustmentStatus: "/leave-adjustment-policies/v1/update-status",
  deleteAdjustment: "/leave-adjustment-policies/v1/delete",

  /* START: Leave Prorate */
  addOtherSetting: "/other-setting/v1/create",
  getOtherSettingData: "/other-setting/v1/get-leave-setting-other-data",
  addLeaveProrateManually: "/leave-prorate/v1/create-manually",
  addLeaveAutoProrateRun: "/leave-prorate/v1/auto-prorate-run-queue",
  addLeaveOldUserAutoProrateRun:
    "/leave-prorate/v1/auto-prorate-run-for-old-user-that-not-in-prorate-state-queue",
  getLeaveProrateDetails: "/leave-prorate/v1/employee-prorate-logs",
  // getLeaveAdjustmentLog: "/leave-prorate/v1/get-leave-adjustment-log",
  getLeaveAdjustmentLog:
    "/leave-prorate/v1/get-leave-adjustment-log-alternative",
  updateLeaveProrate: "/leave-prorate/v1/prorate-update",
  getLeaveType: "/leave-type/v1/data",
  // getLeaveTypeById: "/leave-type/v1/leave-type-details",
  getLeaveProrateEmployeeList: "/leave-prorate/v1/leave-prorate-employee-list",
  getEmployeeProrateList: "/leave-prorate/v1/employee-prorate-list",
  deleteLeaveProrate: "/leave-prorate/v1/prorate-delete",
  getLeaveBalance: "/leave-prorate/v1/leave-balance",
  getLeaveBalanceDetails: "/leave-prorate/v1/leave-balance-details",
  singleEmployeeProrateRun: "/leave-prorate/v1/single-employee-prorate-run",
  downloadEmployeeLeaveBalance:
    "/leave-prorate/v1/download/leave-balance-details",

  /* START: Leave Application */
  addLeaveApplication: "/leave-application/v1/create-web",
  updateLeaveApplication: "/leave-application/v1/update",
  getLeaveApplicationList: "/leave-application/v1/data",
  getLeaveApplicationDetails: "/leave-application/v1/leave-application-details",
  updateLeaveApplicationApproved:
    "/leave-application/v1/leave-application-status-update",
  updateLeaveApplicationReject:
    "/leave-application/v1/leave-application-status-update",
  updateLeaveApplicationCancel:
    "/leave-application/v1/leave-application-status-update",
  getDashboardLeaveAnalyticsData:
    "/leave-application/v1/dashboard-leave-analytics-data-alternative",
  leaveBalanceExport:
    "/leave-prorate/v1/get-all-employee-leave-balance-details",

  /* START: Leave Approval */
  getApprovalSetting: "/approval-setting/v1/data",
  addApprovalSetting: "/approval-setting/v1/create",
  updateApprovalSetting: "/approval-setting/v1/update",
  deleteApprovalSetting: "/approval-setting/v1/delete",

  /* START: Visit */
  getMyVisitList: "/employee-visit/v1/my-visit-list",
  getMyVisitListMinimum: "/employee-visit/v1/my-visit-list-minimum",
  getTeamVisitList: "/employee-visit/v1/team-visit-list",
  getVisitDetails: "/employee-visit/v1/visit-details",
  getVisitListExport: "/employee-visit/v1/visit-list-export",
  getVisitDetailsExport: "/employee-visit/v1/download/visit-data-by-date-range",

  /* START: Tracking Setting */
  updateVisitSetting: "/employee-visit/v1/visit-setting",
  getTrackingSetting: "/live-tracking-setting/v1/get-tracking-setting",
  updateTrackingSetting: "/live-tracking-setting/v1/tracking-setting",
  getTrackingSettingLogs: "/live-tracking-setting/v1/get-tracking-setting-logs",
  getTrackingEmployeeList: "/live-tracking-setting/v1/tracking-employee-list",
  addEmployeeLiveTrackingSetting:
    "/live-tracking-setting/v1/employee-live-tracking-setting",
  getTrackingDataByDateRange: "/live-tracking/v1/tracking-data-by-date-range",

  /* START: Employee Tracking */
  getEmployeeTrackingData: "/live-tracking/v1/tracking-employee-data",
  getEmployeeTrackingAlternative:
    "/live-tracking/v1/tracking-employee-data-alternative",
  getEmployeeTrackingHistory: "/live-tracking/v1/tracking-history-by-employee",
  getEmployeeTrackingDateList: "/live-tracking/v1/tracking-date-by-employee",
  downloadTrackingHistory:
    "/live-tracking/v1/download/tracking-data-by-date-range",
  bariKoiApiHit: "/geo-location/v1/get-hit-by-web",

  /* START: Payroll Setting */
  getPayrollSetting: "/payroll-setting/v1/get-payroll-setting-data",
  getMonthlyPayCycle: "/payroll-setting/v1/get-monthly-pay-cycle",
  updateGrossComponent: "/payroll-setting/v1/update-gross-component",
  uploadGrossSalary: "/payroll-setting/v1/employee-gross-salary-queue",
  downloadGrossSalary: "/payroll-setting/v1/download-employees-gross-salary",
  updatePayrollEnableAndPaySchedule: "/payroll-setting/v1/update-pay-schedule",
  updatePayComponent: "/payroll-setting/v1/update-pay-component",
  getTaxData: "/payroll-setting/v1/get-tax",
  createOrUpdateTax: "/payroll-setting/v1/create-update-tax",
  getOvertime: "/payroll-setting/v1/get-overtime",
  createOvertime: "/payroll-setting/v1/create-overtime",
  getHolidayAllowance: "/payroll-setting/v1/get-holiday-allowance",
  createHolidayAllowance: "/payroll-setting/v1/create-holiday-allowance",
  updateOvertimeStatus: "/payroll-setting/v1/update-component-status",
  getPayComponentSetting: "/payroll-setting/v1/user-pay-components",
  uploadVariableSalary:
    "/payroll-setting/v1/employee-variable-salary-by-admin-queue",
  uploadVariableSalaryForEmployee:
    "/payroll-setting/v1/employee-variable-salary-set-by-admin-queue",
  getVariableSalary: "/payroll-setting/v1/get-variable-salary",
  singleVariableSalaryApprove: "/payroll-setting/v1/variable-salary",
  bulkVariableSalaryApprove: "/payroll-setting/v1/bulk-approve-variable-salary",
  bulkVariableSalaryDelete: "/payroll-setting/v1/bulk-delete-variable-salary",
  getAdditionDeductionSalary:
    "/payroll-setting/v1/get-addition-deduction-salary",
  uploadAdditionDeductionSalary:
    "/payroll-setting/v1/employee-addition-deduction-salary-by-admin-queue",
  singleAdditionDeductionSalaryApprove:
    "/payroll-setting/v1/addition-deduction-salary",
  bulkAdditionDeductionSalaryApprove:
    "/payroll-setting/v1/bulk-approve-addition-deduction-salary",
  getOvertimeSalary: "/payroll-setting/v1/get-overtime-excel-salary",
  uploadOvertimeSalary:
    "/payroll-setting/v1/employee-overtime-salary-by-admin-queue",
  singleOvertimeSalaryApprove: "/payroll-setting/v1/overtime-excel-salary",
  bulkOvertimeSalaryApprove:
    "/payroll-setting/v1/bulk-approve-overtime-excel-salary",
  getHolidayAllowanceSalary:
    "/payroll-setting/v1/get-holiday-allowance-excel-salary",
  uploadHolidayAllowanceSalary:
    "/payroll-setting/v1/employee-holiday-allowance-by-admin",
  singleHolidayAllowanceSalaryApprove:
    "/payroll-setting/v1/holiday-allowance-excel-salary",
  bulkHolidayAllowanceSalaryApprove:
    "/payroll-setting/v1/bulk-approve-holiday-allowance-excel-salary",

  getVariableSalaryId: "/payroll-setting/v1/get-variable-salary-minimum",
  getAdditionDeductionId:
    "/payroll-setting/v1/get-addition-deduction-salary-minimum",
  getOvertimeExcelId: "/payroll-setting/v1/get-overtime-excel-salary-minimum",
  getHolidayAllowanceId:
    "/payroll-setting/v1/get-holiday-allowance-excel-salary-minimum",

  /* START: Employee Salary Setting */
  getEmployeeBreakdownSalaryDetails:
    "/payroll-setting/v1/employee-breakdown-salary-details",
  updateSalaryDetails: "/payroll-setting/v1/employee-component-setting",
  downloadSalaryCertificate:
    "/payroll-setting/v1/download/employee-breakdown-salary-details",

  // Task Queue
  getTaskQueueList: "/salary/v1/queue-list/data",

  // dashboard
  getEmployeeCartData:
    "/employee-management/v1/dashboard-cart-analytics-data-alternative",
  // getEmployeeCartData: "/employee-management/v1/dashboard-cart-analytics-data",
  // getDashboardLeaveData: "/leave-application/v1/dashboard-leave-analytics-data",
  getDashboardLeaveData:
    "/leave-application/v1/dashboard-leave-analytics-data-alternative",

  // notification
  getNotifications: "/notification/v1/get-support-notification-list",
  notificationStatus: "/notification/v1/status",
  getNotificationSetting: "/notifications-setting/v1/notifications",
  createNotificationSetting: "/notifications-setting/v1/notifications",
  getNotificationTemplates: "/notifications-setting/v1/templates",
  getNotificationTemplatesDetails: "/notifications-setting/v1/templates",
  createNotificationTemplates: "/notifications-setting/v1/templates",
  updateNotificationTemplates: "/notifications-setting/v1/templates",
  updateNotificationTemplatesStatus: "/notifications-setting/v1/templates",

  // payroll
  generateSalary: "/salary/v1/generate-salary-queue",
  getSalarySummary: "/salary/v1/get-salary-summary",
  getSalaryReport: "/salary/v1/get-salary-report",
  getSalaryReportDetails: "/salary/v1/get-salary-report-details",
  getEmployeePayReportDetails: "/salary/v1/employee-pay-report-details",
  // downloadPayrollPayReport: "/salary/v1/download/generate-pdf",
  downloadPayrollPayReport:
    "/salary/v1/download/generate-pdf-version-alternative",
  paySlipDisbursement: "/salary/v1/update-status",
  reGenerateSalary: "/salary/v1/regenerate-payslips-queue",
  getDownloadBkashDisbursement: "/salary/v1/download-bkash-disbusement-report",
  taxReportList: "/salary/v1/tax-report",
  downloadTaxReportSingle: "/salary/v1/tax-report-single-user",
  deletePayslip: "/salary/v1/delete-payslip-queue",
  sendSalaryReport: "/salary/v1/send-salary-report-to-portal",

  // device
  getDeviceList: "/attendance-device/list",
  getDeviceAllocated: "/attendance-device/get-allocated-users",
  getDeviceUnAllocated: "/attendance-device/get-unallocated-users",
  allocatedUserInDevice: "/attendance-device/allocate-user-to-device",
  revokeUserFromDevice: "/attendance-device/revoke-user-from-device",
  startEnrollmentInDevice: "/attendance-device/start-enrollment",
  stopEnrollmentDevice: "/attendance-device/stop-enrollment",
  createBulkUsers: "/attendance-device/create-bulk-users",
  addApiToken: "/attendance-device/update-device-token",
  getApiToken: "/attendance-device/get-device-api-token",

  // reports
  getReportList: "/attendance-shift-report/v1/reports",
  customAttendanceReportReq:
    "/attendance-shift-report/v1/custom-attendance-report",
  customAttendanceReportReqOnlyTime:
    "/attendance-shift-report/v1/custom-attendance-report-only-attendance-time",
  dailyAttendanceReport: "/attendance-shift-report/v1/daily-attendance-report",
  customAttendanceReportByEmployee:
    "/attendance-shift-report/v1/custom-attendace-report-by-employee",
  shiftAssignListReport: "/attendance-shift-report/v1/get-shift-assign-list",
  employeeReport: "/employee-report/v1/download-employee-list",
  disbursedPayslip: "/payroll-report/v1/get-disbursed-payslip-summary",
  overtimeSummary: "/payroll-report/v1/get-overtime-summary",
  payReport: "/payroll-report/v1/get-salary-report",
  payReportDetails: "/payroll-report/v1/get-salary-report-details",
  departmentWiseSalaryReport:
    "/payroll-report/v1/get-department-wise-salary-report-details",
  downloadTaxReport: "/payroll-report/v1/download-tax-report",
  leaveApplicationReport: "/leave-report/v1/leave-application-list",
  employeeLeaveBalanceDetailsReport:
    "/leave-report/v1/download-all-employee-leave-balance-details-report",
  getExpenseDetailsReport: "/expense-report/v1/get-expense-details-report",
  getExpenseReport: "/expense-report/v1/get-expense-report",
  getVisitReport: "/visit-tracking-report/v1/get-visit-list",
  trackingDetailsReport:
    "/visit-tracking-report/v1/get-tracking-data-by-employee",
  supportListReport: "/support-report/v1/get-support-list",

  /* START: Performance Management */
  createKpi: "/kpi/v1/create",
  updateKpi: "/kpi/v1/update",
  getAllKpi: "/kpi/v1/get-all",
  getSingleKpi: "/kpi/v1/get-by-id",
  createAppraisal: "/kpi/v1/appraisal",
  getOwnKpi: "/kpi/own-submitted",
  getOwnKpiByDepartment: "/kpi/v1/get-department-wise-kpis",
  getOwnSingleKpi: "/kpi/employee-kpi",
  lineManagerSubmitKpi: "/kpi/v1/employee-kpi/update-comment",
  submitOwnKpi: "/kpi/v1/sumit-employee-kpi-data",
  ownAppraisalSubmit: "/kpi/v1/apprisal/submit",
  teamAppraisalSubmit: "/kpi/v1/line-manager/apprisal/sbumit",
  recommendationForPromotion: "/kpi/v1/admin/update-recommendation",

  /* START: KPI Management */
  addKPICycle: "/performance-management/v1/cycle/create",
  updateKPICycle: "/performance-management/v1/cycle/update",
  getKPICycleList: "/performance-management/v1/cycle/data",
  getKPICycleDetails: "/performance-management/v1/cycle/details",
  addAssignOneKPIMultiUser:
    "/performance-management/v1/kpi/assign-one-cycle-to-many-employees",
  addAssignMultiKPISingleUser:
    "/performance-management/v1/kpi/assign-multiple-cycle-to-one-employee",
  getUserAPIAssignedList: "/performance-management/v1/kpi/employee",
  updateEvaluateUser: "/performance-management/v1/kpi/evaluate",

  /* START: Recruitment Management */
  getAllJobPost: "/recruitment-management/v1/job-posts/data",
  addJob: "/recruitment-management/v1/job-post/create",
  getJobDetails: "/recruitment-management/v1/job-post/details",
  deleteJob: "/recruitment-management/v1/job-post/delete",
  updateJob: "/recruitment-management/v1/job-post/update",
  updateJobStatus: "/recruitment-management/v1/job-posts/status-update",
  updateStatusJob: "/recruitment-management/v1/job-posts/status-update",

  getAppliedJob: "/recruitment-management/v1/job-applications/data",
  applyJob: "/recruitment-management/v1/job-application/create",
  jobShortlistOrReject:
    "/recruitment-management/v1/job-applications/bulk-status-update",

  getInterviewList: "/recruitment-management/v1/interview/data",
  createInterview:
    "/recruitment-management/v1/interview/bulk-create-with-details",
  interviewBulkStatus:
    "/recruitment-management/v1/interview/bulk-status-update",
  interviewBulkOfferStatus:
    "/recruitment-management/v1/interviews/bulk-offer-status-update",

  // Petty Cash
  getPettyCash: "/petty-cash/v1/data",
  getPettyCashId: "/petty-cash/v1/data-minimum",
  getPettyCashDetails: "/petty-cash/v1/details",
  pettyCashSend: "/petty-cash/v1/send-to-portal",
};
